enum Types {
  NEW_ENVIRONMENT_REQUEST = 'NEW_ENVIRONMENT_REQUEST',
  NEW_ENVIRONMENT_FULFILLED = 'NEW_ENVIRONMENT_FULFILLED',
  NEW_ENVIRONMENT_REJECTED = 'NEW_ENVIRONMENT_REJECTED',

  TOGGLE_BLOCK_MULTIPLE_INSTANCES_REQUEST = 'TOGGLE_BLOCK_MULTIPLE_INSTANCES_REQUEST',
  TOGGLE_BLOCK_MULTIPLE_INSTANCES_FULFILLED = 'TOGGLE_BLOCK_MULTIPLE_INSTANCES_FULFILLED',
  TOGGLE_BLOCK_MULTIPLE_INSTANCES_REJECTED = 'TOGGLE_BLOCK_MULTIPLE_INSTANCES_REJECTED',

  TOGGLE_BLOCK_INSTANCES_REQUEST = 'TOGGLE_BLOCK_INSTANCE_REQUEST',
  TOGGLE_BLOCK_INSTANCES_FULFILLED = 'TOGGLE_BLOCK_INSTANCE_FULFILLED',
  TOGGLE_BLOCK_INSTANCES_REJECTED = 'TOGGLE_BLOCK_INSTANCE_REJECTED',

  TERMINATE_MULTIPLE_INSTANCE_REQUEST = 'TERMINATE_MULTIPLE_INSTANCE_REQUEST',
  TERMINATE_MULTIPLE_INSTANCE_FULFILLED = 'TERMINATE_MULTIPLE_INSTANCE_FULFILLED',
  TERMINATE_MULTIPLE_INSTANCE_REJECTED = 'TERMINATE_MULTIPLE_INSTANCE_REJECTED',

  REMOVE_MULTIPLE_MODELS_REQUEST = 'REMOVE_MULTIPLE_MODELS_REQUEST',
  REMOVE_MULTIPLE_MODELS_FULFILLED = 'REMOVE_MULTIPLE_MODELS_FULFILLED',
  REMOVE_MULTIPLE_MODELS_REJECTED = 'REMOVE_MULTIPLE_MODELS_REJECTED',

  GET_ALARMS_INSTANCE_REQUEST = 'GET_ALARMS_INSTANCE_REQUEST',
  GET_ALARMS_INSTANCE_FULFILLED = 'GET_ALARMS_INSTANCE_FULFILLED',
  GET_ALARMS_INSTANCE_REJECTED = 'GET_ALARMS_INSTANCE_REJECTED',

  SUBMIT_KEEP_USER_REQUEST = 'SUBMIT_KEEP_USER_REQUEST',
  SUBMIT_KEEP_USER_FULFILLED = 'SUBMIT_KEEP_USER_FULFILLED',
  SUBMIT_KEEP_USER_REJECTED = 'SUBMIT_KEEP_USER_REJECTED',

  EDIT_MAINTENANCE_ENVIRONMENTS_REQUEST = 'EDIT_MAINTENANCE_ENVIRONMENTS_REQUEST',
  EDIT_MAINTENANCE_ENVIRONMENTS_FULFILLED = 'EDIT_MAINTENANCE_ENVIRONMENTS_FULFILLED',
  EDIT_MAINTENANCE_ENVIRONMENTS_REJECTED = 'EDIT_MAINTENANCE_ENVIRONMENTS_REJECTED',

  DUPLICATE_MODEL_REQUEST = 'DUPLICATE_MODEL_REQUEST',
  DUPLICATE_MODEL_FULFILLED = 'DUPLICATE_MODEL_FULFILLED',
  DUPLICATE_MODEL_REJECTED = 'DUPLICATE_MODEL_REJECTED',

  GET_ALL_IMAGENS_LOGS_REQUEST = 'GET_ALL_IMAGENS_LOGS_REQUEST',
  GET_ALL_IMAGENS_LOGS_FULFILLED = 'GET_ALL_IMAGENS_LOGS_FULFILLED',
  GET_ALL_IMAGENS_LOGS_REJECTED = 'GET_ALL_IMAGENS_LOGS_REJECTED',

  REQUESTING_USER_RECONNECTION_REQUEST = 'REQUESTING_USER_RECONNECTION_REQUEST',
  REQUESTING_USER_RECONNECTION_FULFILLED = 'REQUESTING_USER_RECONNECTION_FULFILLED',
  REQUESTING_USER_RECONNECTION_REJECTED = 'REQUESTING_USER_RECONNECTION_REJECTED',

  STANDARD_NEW_PUBLICATION_REQUEST = 'STANDARD_NEW_PUBLICATION_REQUEST',
  STANDARD_NEW_PUBLICATION_FULFILLED = 'STANDARD_NEW_PUBLICATION_FULFILLED',
  STANDARD_NEW_PUBLICATION_REJECTED = 'STANDARD_NEW_PUBLICATION_REJECTED',

  PUBLISH_NEW_IMAGE_REQUEST = 'PUBLISH_NEW_IMAGE_REQUEST',
  PUBLISH_NEW_IMAGE_FULFILLED = 'PUBLISH_NEW_IMAGE_FULFILLED',
  PUBLISH_NEW_IMAGE_REJECTED = 'PUBLISH_NEW_IMAGE_REJECTED',

  REMOVE_ENVIRONMENT_REQUEST = 'REMOVE_ENVIRONMENT_REQUEST',
  REMOVE_ENVIRONMENT_FULFILLED = 'REMOVE_ENVIRONMENT_FULFILLED',
  REMOVE_ENVIRONMENT_REJECTED = 'REMOVE_ENVIRONMENT_REJECTED',

  START_SERVER_REQUEST = 'START_SERVER_REQUEST',
  START_SERVER_FULFILLED = 'START_SERVER_FULFILLED',
  START_SERVER_REJECTED = 'START_SERVER_REJECTED',

  STOP_SERVER_REQUEST = 'STOP_SERVER_REQUEST',
  STOP_SERVER_FULFILLED = 'STOP_SERVER_FULFILLED',
  STOP_SERVER_REJECTED = 'STOP_SERVER_REJECTED',

  RESTART_SERVER_REQUEST = 'RESTART_SERVER_REQUEST',
  RESTART_SERVER_FULFILLED = 'RESTART_SERVER_FULFILLED',
  RESTART_SERVER_REJECTED = 'RESTART_SERVER_REJECTED',

  NEW_STOP_TIME_SERVER_PREPARATION_REQUEST = 'NEW_STOP_TIME_SERVER_PREPARATION_REQUEST',
  NEW_STOP_TIME_SERVER_PREPARATION_FULFILLED = 'NEW_STOP_TIME_SERVER_PREPARATION_FULFILLED',
  NEW_STOP_TIME_SERVER_PREPARATION_REJECTED = 'NEW_STOP_TIME_SERVER_PREPARATION_REJECTED',

  GET_MAINTENANCE_REQUEST = 'GET_MAINTENANCE_CONFIG',
  GET_MAINTENANCE_FULFILLED = 'GET_MAINTENANCE_CONFIG_FULFILLED',
  GET_MAINTENANCE_REJECTED = 'GET_MAINTENANCE_CONFIG_REJECTED',

  UNLINK_INSTANCE_REQUEST = 'UNLINK_INSTANCE_REQUEST',
  UNLINK_INSTANCE_FULFILLED = 'UNLINK_INSTANCE_FULFILLED',
  UNLINK_INSTANCE_REJECTED = 'UNLINK_INSTANCE_REJECTED',

  ACTIVATE_INSTANCE_REQUEST = 'ACTIVATE_INSTANCE_REQUEST',
  ACTIVATE_INSTANCE_FULFILLED = 'ACTIVATE_INSTANCE_FULFILLED',
  ACTIVATE_INSTANCE_REJECTED = 'ACTIVATE_INSTANCE_REJECTED',

  GET_HRLS_ENVIRONMENT_REQUEST = 'GET_HRLS_ENVIRONMENT_REQUEST',
  GET_HRLS_ENVIRONMENT_FULFILLED = 'GET_HRLS_ENVIRONMENT_FULFILLED',
  GET_HRLS_ENVIRONMENT_REJECTED = 'GET_HRLS_ENVIRONMENT_REJECTED',

  GET_SESSIONS_CHART_REQUEST = 'GET_SESSIONS_CHART_REQUEST',
  GET_SESSIONS_CHART_FULFILLED = 'GET_SESSIONS_CHART_FULFILLED',
  GET_SESSIONS_CHART_REJECTED = 'GET_SESSIONS_CHART_REJECTED',

  GET_INSTANCE_CHART_REQUEST = 'GET_INSTANCE_CHART_REQUEST',
  GET_INSTANCE_CHART_FULFILLED = 'GET_INSTANCE_CHART_FULFILLED',
  GET_INSTANCE_CHART_REJECTED = 'GET_INSTANCE_CHART_REJECTED',

  EDIT_ENVIRONMENT_REQUEST = 'EDIT_ENVIRONMENT_REQUEST',
  EDIT_ENVIRONMENT_FULFILLED = 'EDIT_ENVIRONMENT_FULFILLED',
  EDIT_ENVIRONMENT_REJECTED = 'EDIT_ENVIRONMENT_REJECTED',

  REGISTER_NEW_INSTANCE_REQUEST = 'REGISTER_NEW_INSTANCE_REQUEST',
  REGISTER_NEW_INSTANCE_FULFILLED = 'REGISTER_NEW_INSTANCE_FULFILLED',
  REGISTER_NEW_INSTANCE_REJECTED = 'REGISTER_NEW_INSTANCE_REJECTED',

  GET_ALL_SESSIONS_IN_INSTANCE_REQUEST = 'GET_ALL_SESSIONS_IN_INSTANCE_REQUEST',
  GET_ALL_SESSIONS_IN_INSTANCE_FULFILLED = 'GET_ALL_SESSIONS_IN_INSTANCE_FULFILLED',
  GET_ALL_SESSIONS_IN_INSTANCE_REJECTED = 'GET_ALL_SESSIONS_IN_INSTANCE_REJECTED',

  GET_INSTANCE_OBSERVABILITY_REQUEST = 'GET_INSTANCE_OBSERVABILITY_REQUEST',
  GET_INSTANCE_OBSERVABILITY_FULFILLED = 'GET_INSTANCE_OBSERVABILITY_FULFILLED',
  GET_INSTANCE_OBSERVABILITY_REJECTED = 'GET_INSTANCE_OBSERVABILITY_REJECTED',

  REMOVE_SESSIONS_INSTANCE_REQUEST = 'REMOVE_SESSIONS_INSTANCE_REQUEST',
  REMOVE_SESSIONS_INSTANCE_FULFILLED = 'REMOVE_SESSIONS_INSTANCE_FULFILLED',
  REMOVE_SESSIONS_INSTANCE_REJECTED = 'REMOVE_SESSIONS_INSTANCE_REJECTED',

  GET_ENVIRONMENT_BEHAVIOR_REQUEST = 'GET_ENVIRONMENT_BEHAVIOR_REQUEST',
  GET_ENVIRONMENT_BEHAVIOR_FULFILLED = 'GET_ENVIRONMENT_BEHAVIOR_FULFILLED',
  GET_ENVIRONMENT_BEHAVIOR_REJECTED = 'GET_ENVIRONMENT_BEHAVIOR_REJECTED',

  EDIT_ENVIRONMENT_BEHAVIOR_REQUEST = 'EDIT_ENVIRONMENT_BEHAVIOR_REQUEST',
  EDIT_ENVIRONMENT_BEHAVIOR_FULFILLED = 'EDIT_ENVIRONMENT_BEHAVIOR_FULFILLED',
  EDIT_ENVIRONMENT_BEHAVIOR_REJECTED = 'EDIT_ENVIRONMENT_BEHAVIOR_REJECTED',

  GET_ALL_ENVIRONMENTS_REQUEST = 'GET_ALL_ENVIRONMENTS_REQUEST',
  GET_ALL_ENVIRONMENTS_FULFILLED = 'GET_ALL_ENVIRONMENTS_FULFILLED',
  GET_ALL_ENVIRONMENTS_REJECTED = 'GET_ALL_ENVIRONMENTS_REJECTED',

  GET_ALL_ENVIRONMENTS_OPERATOR_REQUEST = 'GET_ALL_ENVIRONMENTS_OPERATOR_REQUEST',
  GET_ALL_ENVIRONMENTS_OPERATOR_FULFILLED = 'GET_ALL_ENVIRONMENTS_OPERATOR_FULFILLED',
  GET_ALL_ENVIRONMENTS_OPERATOR_REJECTED = 'GET_ALL_ENVIRONMENTS_OPERATOR_REJECTED',

  GET_ENVIRONMENT_REQUEST = 'GET_ENVIRONMENT_REQUEST',
  GET_ENVIRONMENT_FULFILLED = 'GET_ENVIRONMENT_FULFILLED',
  GET_ENVIRONMENT_REJECTED = 'GET_ENVIRONMENT_REJECTED',

  REMOVE_INSTANCE_REQUEST = 'REMOVE_INSTANCE_REQUEST',
  REMOVE_INSTANCE_FULFILLED = 'REMOVE_INSTANCE_FULFILLED',
  REMOVE_INSTANCE_REJECTED = 'REMOVE_INSTANCE_REJECTED',

  TERMINATE_INSTANCE_REQUEST = 'TERMINATE_INSTANCE_REQUEST',
  TERMINATE_INSTANCE_FULFILLED = 'TERMINATE_INSTANCE_FULFILLED',
  TERMINATE_INSTANCE_REJECTED = 'TERMINATE_INSTANCE_REJECTED',

  REBOOT_INSTANCE_REQUEST = 'REBOOT_INSTANCE_REQUEST',
  REBOOT_INSTANCE_FULFILLED = 'REBOOT_INSTANCE_FULFILLED',
  REBOOT_INSTANCE_REJECTED = 'REBOOT_INSTANCE_REJECTED',

  EDIT_SECURITY_REQUEST = 'EDIT_SECURITY_REQUEST',
  EDIT_SECURITY_FULFILLED = 'EDIT_SECURITY_FULFILLED',
  EDIT_SECURITY_REJECTED = 'EDIT_SECURITY_REJECTED',

  GET_SECURITY_STATE_REQUEST = 'GET_SECURITY_STATE_REQUEST',
  GET_SECURITY_STATE_FULFILLED = 'GET_SECURITY_STATE_FULFILLED',
  GET_SECURITY_STATE_REJECTED = 'GET_SECURITY_STATE_REJECTED',

  GET_ALL_INSTANCES_REQUEST = 'GET_ALL_INSTANCES_REQUEST',
  GET_ALL_INSTANCES_FULFILLED = 'GET_ALL_INSTANCES_FULFILLED',
  GET_ALL_INSTANCES_REJECTED = 'GET_ALL_INSTANCES_REJECTED',

  GET_PREPARATION_SERVER_REQUEST = 'GET_PREPARATION_SERVER_REQUEST',
  GET_PREPARATION_SERVER_FULFILLED = 'GET_PREPARATION_SERVER_FULFILLED',
  GET_PREPARATION_SERVER_REJECTED = 'GET_PREPARATION_SERVER_REJECTED',

  GET_SUPPORT_SERVERS_REQUEST = 'GET_SUPPORT_SERVERS_REQUEST',
  GET_SUPPORT_SERVERS_FULFILLED = 'GET_SUPPORT_SERVERS_FULFILLED',
  GET_SUPPORT_SERVERS_REJECTED = 'GET_SUPPORT_SERVERS_REJECTED',

  GET_ALL_SERVERS_REQUEST = 'GET_ALL_SERVERS_REQUEST',
  GET_ALL_SERVERS_FULFILLED = 'GET_ALL_SERVERS_FULFILLED',
  GET_ALL_SERVERS_REJECTED = 'GET_ALL_SERVERS_REJECTED',

  GET_ALL_MODELS_REQUEST = 'GET_ALL_MODELS_REQUEST',
  GET_ALL_MODELS_FULFILLED = 'GET_ALL_MODELS_FULFILLED',
  GET_ALL_MODELS_REJECTED = 'GET_ALL_MODELS_REJECTED',

  GET_MODEL_REQUEST = 'GET_MODEL_REQUEST',
  GET_MODEL_FULFILLED = 'GET_MODEL_FULFILLED',
  GET_MODEL_REJECTED = 'GET_MODEL_REJECTED',

  REGISTER_MODEL_REQUEST = 'REGISTER_MODEL_REQUEST',
  REGISTER_MODEL_FULFILLED = 'REGISTER_MODEL_FULFILLED',
  REGISTER_MODEL_REJECTED = 'REGISTER_MODEL_REJECTED',

  EDIT_MODEL_REQUEST = 'EDIT_MODEL_REQUEST',
  EDIT_MODEL_FULFILLED = 'EDIT_MODEL_FULFILLED',
  EDIT_MODEL_REJECTED = 'EDIT_MODEL_REJECTED',

  REMOVE_MODEL_REQUEST = 'REMOVE_MODEL_REQUEST',
  REMOVE_MODEL_FULFILLED = 'REMOVE_MODEL_FULFILLED',
  REMOVE_MODEL_REJECTED = 'REMOVE_MODEL_REJECTED',

  ATTACH_SERVER_REQUEST = 'ATTACH_SERVER_REQUEST',
  ATTACH_SERVER_FULFILLED = 'ATTACH_SERVER_FULFILLED',
  ATTACH_SERVER_REJECTED = 'ATTACH_SERVER_REJECTED',

  DETACH_SERVER_REQUEST = 'DETACH_SERVER_REQUEST',
  DETACH_SERVER_FULFILLED = 'DETACH_SERVER_FULFILLED',
  DETACH_SERVER_REJECTED = 'DETACH_SERVER_REJECTED',

  GET_PROVIDER_RESOURCES_REQUEST = 'GET_PROVIDER_RESOURCES_REQUEST',
  GET_PROVIDER_RESOURCES_FULFILLED = 'GET_PROVIDER_RESOURCES_FULFILLED',
  GET_PROVIDER_RESOURCES_REJECTED = 'GET_PROVIDER_RESOURCES_REJECTED',

  GET_AWS_RESOURCES_REQUEST = 'GET_AWS_RESOURCES_REQUEST',
  GET_OCI_RESOURCES_REQUEST = 'GET_OCI_RESOURCES_REQUEST',

  GET_BOOT_VOLUMES_REQUEST = 'GET_BOOT_VOLUMES_REQUEST',
  GET_BOOT_VOLUMES_FULFILLED = 'GET_BOOT_VOLUMES_FULFILLED',
  GET_BOOT_VOLUMES_REJECTED = 'GET_BOOT_VOLUMES_REJECTED',

  GET_BOOT_VOLUME_BACKUPS_REQUEST = 'GET_BOOT_VOLUME_BACKUPS_REQUEST',
  GET_BOOT_VOLUME_BACKUPS_FULFILLED = 'GET_BOOT_VOLUME_BACKUPS_FULFILLED',
  GET_BOOT_VOLUME_BACKUPS_REJECTED = 'GET_BOOT_VOLUME_BACKUPS_REJECTED',

  GET_SECURITY_GROUPS_REQUEST = 'GET_SECURITY_GROUPS_REQUEST',
  GET_SECURITY_GROUPS_FULFILLED = 'GET_SECURITY_GROUPS_FULFILLED',
  GET_SECURITY_GROUPS_REJECTED = 'GET_SECURITY_GROUPS_REJECTED',

  GET_ZONES_REQUEST = 'GET_ZONES_REQUEST',
  GET_ZONES_FULFILLED = 'GET_ZONES_FULFILLED',
  GET_ZONES_REJECTED = 'GET_ZONES_REJECTED',

  GET_SUBNETS_REQUEST = 'GET_SUBNETS_REQUEST',
  GET_SUBNETS_FULFILLED = 'GET_SUBNETS_FULFILLED',
  GET_SUBNETS_REJECTED = 'GET_SUBNETS_REJECTED',

  GET_KEY_PAIRS_REQUEST = 'GET_KEY_PAIRS_REQUEST',
  GET_KEY_PAIRS_FULFILLED = 'GET_KEY_PAIRS_FULFILLED',
  GET_KEY_PAIRS_REJECTED = 'GET_KEY_PAIRS_REJECTED',

  GET_IMAGES_REQUEST = 'GET_IMAGES_REQUEST',
  GET_IMAGES_FULFILLED = 'GET_IMAGES_FULFILLED',
  GET_IMAGES_REJECTED = 'GET_IMAGES_REJECTED',

  GET_LIST_PROVIDER_RESOURCES_REQUEST = 'GET_LIST_PROVIDER_RESOURCES_REQUEST',
  GET_LIST_PROVIDER_RESOURCES_FULFILLED = 'GET_LIST_PROVIDER_RESOURCES_FULFILLED',
  GET_LIST_PROVIDER_RESOURCES_REJECTED = 'GET_LIST_PROVIDER_RESOURCES_REJECTED',

  GET_FLAVORS_REQUEST = 'GET_FLAVORS_REQUEST',
  GET_FLAVORS_FULFILLED = 'GET_FLAVORS_FULFILLED',
  GET_FLAVORS_REJECTED = 'GET_FLAVORS_REJECTED',

  STOP_TIME_REQUEST = 'STOP_TIME_REQUEST',
  STOP_TIME_FULFILLED = 'STOP_TIME_FULFILLED',
  STOP_TIME_REJECTED = 'STOP_TIME_REJECTED',

  CLEAN_ENVIRONMENT_REQUEST = 'CLEAN_ENVIRONMENT_REQUEST',

  CONNECT_AS_REQUEST = 'CONNECT_AS_REQUEST',
  CONNECT_AS_FULFILLED = 'CONNECT_AS_FULFILLED',
  CONNECT_AS_REJECTED = 'CONNECT_AS_REJECTED',

  GET_DASHBOARD_SESSIONS_GRAPH_REQUEST = 'GET_DASHBOARD_SESSIONS_GRAPH_REQUEST',
  GET_DASHBOARD_ENVIRONMENT_COST_GRAPH_REQUEST = 'GET_DASHBOARD_ENVIRONMENT_COST_GRAPH_REQUEST',

  GET_DASHBOARD_SESSIONS_GRAPH_FULFILLED = 'GET_DASHBOARD_SESSIONS_GRAPH_FULFILLED',
  GET_DASHBOARD_ENVIRONMENT_COST_GRAPH_FULFILLED = 'GET_DASHBOARD_ENVIRONMENT_COST_GRAPH_FULFILLED',

  GET_DASHBOARD_SESSIONS_GRAPH_REJECTED = 'GET_DASHBOARD_SESSIONS_GRAPH_REJECTED',
  GET_DASHBOARD_ENVIRONMENT_COST_GRAPH_REJECTED = 'GET_DASHBOARD_ENVIRONMENT_COST_GRAPH_REJECTED',

  SET_PERIOD_FILTER = 'SET_PERIOD_FILTER',
  SET_PERFORMANCE_DATE_FILTER = 'SET_PERFORMANCE_DATE_FILTER',
  SET_ENVIRONMENT_COST_PERIOD_FILTER = 'SET_ENVIRONMENT_COST_PERIOD_FILTER',

  GET_FLAVORS_COST_REQUEST = 'GET_FLAVORS_COST_REQUEST',
  GET_FLAVORS_COST_FULFILLED = 'GET_FLAVORS_COST_FULFILLED',
  GET_FLAVORS_COST_REJECTED = 'GET_FLAVORS_COST_REJECTED',
  SET_FLAVORS_COST_PERIOD_FILTER = 'SET_FLAVORS_COST_PERIOD_FILTER',

  GET_ALL_APPLICATIONS_AUTOSKY_REQUEST = 'GET_ALL_APPLICATIONS_AUTOSKY_REQUEST',
  GET_ALL_APPLICATIONS_AUTOSKY_FULFILLED = 'GET_ALL_APPLICATIONS_AUTOSKY_FULFILLED',
  GET_ALL_APPLICATIONS_AUTOSKY_REJECTED = 'GET_ALL_APPLICATIONS_AUTOSKY_REJECTED',

  GET_CLIENTS_APPLICATIONS_AUTOSKY_REQUEST = 'GET_CLIENTS_APPLICATIONS_AUTOSKY_REQUEST',
  GET_CLIENTS_APPLICATIONS_AUTOSKY_FULFILLED = 'GET_CLIENTS_APPLICATIONS_AUTOSKY_FULFILLED',
  GET_CLIENTS_APPLICATIONS_AUTOSKY_REJECTED = 'GET_CLIENTS_APPLICATIONS_AUTOSKY_REJECTED',

  RENAME_CLIENTS_APPLICATIONS_AUTOSKY_REQUEST = 'RENAME_CLIENTS_APPLICATIONS_AUTOSKY_REQUEST',
  RENAME_CLIENTS_APPLICATIONS_AUTOSKY_FULFILLED = 'RENAME_CLIENTS_APPLICATIONS_AUTOSKY_FULFILLED',
  RENAME_CLIENTS_APPLICATIONS_AUTOSKY_REJECTED = 'RENAME_CLIENTS_APPLICATIONS_AUTOSKY_REJECTED',

  REMOVE_CLIENTS_APPLICATIONS_AUTOSKY_REQUEST = 'REMOVE_CLIENTS_APPLICATIONS_AUTOSKY_REQUEST',
  REMOVE_CLIENTS_APPLICATIONS_AUTOSKY_FULFILLED = 'REMOVE_CLIENTS_APPLICATIONS_AUTOSKY_FULFILLED',
  REMOVE_CLIENTS_APPLICATIONS_AUTOSKY_REJECTED = 'REMOVE_CLIENTS_APPLICATIONS_AUTOSKY_REJECTED',

  CHANGE_STATE_CLIENTS_APPLICATIONS_AUTOSKY_REQUEST = 'CHANGE_STATE_CLIENTS_APPLICATIONS_AUTOSKY_REQUEST',
  CHANGE_STATE_CLIENTS_APPLICATIONS_AUTOSKY_FULFILLED = 'CHANGE_STATE_CLIENTS_APPLICATIONS_AUTOSKY_FULFILLED',
  CHANGE_STATE_CLIENTS_APPLICATIONS_AUTOSKY_REJECTED = 'CHANGE_STATE_CLIENTS_APPLICATIONS_AUTOSKY_REJECTED',

  INCLUDE_CLIENTS_APPLICATIONS_AUTOSKY_REQUEST = 'INCLUDE_CLIENTS_APPLICATIONS_AUTOSKY_REQUEST',
  INCLUDE_CLIENTS_APPLICATIONS_AUTOSKY_FULFILLED = 'INCLUDE_CLIENTS_APPLICATIONS_AUTOSKY_FULFILLED',
  INCLUDE_CLIENTS_APPLICATIONS_AUTOSKY_REJECTED = 'INCLUDE_CLIENTS_APPLICATIONS_AUTOSKY_REJECTED',

  GET_CLIENTS_TO_INCLUDE_APPLICATIONS_AUTOSKY_REQUEST = 'GET_CLIENTS_TO_INCLUDE_APPLICATIONS_AUTOSKY_REQUEST',
  GET_CLIENTS_TO_INCLUDE_APPLICATIONS_AUTOSKY_FULFILLED = 'GET_CLIENTS_TO_INCLUDE_APPLICATIONS_AUTOSKY_FULFILLED',
  GET_CLIENTS_TO_INCLUDE_APPLICATIONS_AUTOSKY_REJECTED = 'GET_CLIENTS_TO_INCLUDE_APPLICATIONS_AUTOSKY_REJECTED',

  GET_ALL_APPLICATIONS_PLATFORM_REQUEST = 'GET_ALL_APPLICATIONS_PLATFORM_REQUEST',
  GET_ALL_APPLICATIONS_PLATFORM_FULFILLED = 'GET_ALL_APPLICATIONS_PLATFORM_FULFILLED',
  GET_ALL_APPLICATIONS_PLATFORM_REJECTED = 'GET_ALL_APPLICATIONS_PLATFORM_REJECTED',

  GET_CLIENTS_APPLICATIONS_PLATFORM_REQUEST = 'GET_CLIENTS_APPLICATIONS_PLATFORM_REQUEST',
  GET_CLIENTS_APPLICATIONS_PLATFORM_FULFILLED = 'GET_CLIENTS_APPLICATIONS_PLATFORM_FULFILLED',
  GET_CLIENTS_APPLICATIONS_PLATFORM_REJECTED = 'GET_CLIENTS_APPLICATIONS_PLATFORM_REJECTED',

  REMOVE_CLIENTS_APPLICATIONS_PLATFORM_REQUEST = 'REMOVE_CLIENTS_APPLICATIONS_PLATFORM_REQUEST',
  REMOVE_CLIENTS_APPLICATIONS_PLATFORM_FULFILLED = 'REMOVE_CLIENTS_APPLICATIONS_PLATFORM_FULFILLED',
  REMOVE_CLIENTS_APPLICATIONS_PLATFORM_REJECTED = 'REMOVE_CLIENTS_APPLICATIONS_PLATFORM_REJECTED',

  MIGRATE_ENVIRONMENT_REQUEST = 'MIGRATE_ENVIRONMENT_REQUEST',
  MIGRATE_ENVIRONMENT_FULFILLED = 'MIGRATE_ENVIRONMENT_FULFILLED',
  MIGRATE_ENVIRONMENT_REJECTED = 'MIGRATE_ENVIRONMENT_REJECTED',
  SET_MIGRATE_ERRORS = 'SET_MIGRATE_ERRORS',

  SET_ENVIRONMENT_AVG_MAX_FILTER_CPU = 'SET_ENVIRONMENT_AVG_MAX_FILTER_CPU',
  SET_ENVIRONMENT_AVG_MAX_FILTER_MEMORY = 'SET_ENVIRONMENT_AVG_MAX_FILTER_MEMORY',
  SET_ENVIRONMENT_AVG_MAX_FILTER_OPERATIONAL_TIME = 'SET_ENVIRONMENT_AVG_MAX_FILTER_OPERATIONAL_TIME',

  GET_ENVIRONMENT_PERFORMANCE_CPU_REQUEST = 'GET_ENVIRONMENT_PERFORMANCE_CPU_REQUEST',
  GET_ENVIRONMENT_PERFORMANCE_CPU_FULFILLED = 'GET_ENVIRONMENT_PERFORMANCE_CPU_FULFILLED',
  GET_ENVIRONMENT_PERFORMANCE_CPU_REJECTED = 'GET_ENVIRONMENT_PERFORMANCE_CPU_REJECTED',

  GET_ENVIRONMENT_PERFORMANCE_MEMORY_REQUEST = 'GET_ENVIRONMENT_PERFORMANCE_MEMORY_REQUEST',
  GET_ENVIRONMENT_PERFORMANCE_MEMORY_FULFILLED = 'GET_ENVIRONMENT_PERFORMANCE_MEMORY_FULFILLED',
  GET_ENVIRONMENT_PERFORMANCE_MEMORY_REJECTED = 'GET_ENVIRONMENT_PERFORMANCE_MEMORY_REJECTED',

  GET_ENVIRONMENT_PERFORMANCE_OPERATIONAL_TIME_REQUEST = 'GET_ENVIRONMENT_PERFORMANCE_OPERATIONAL_TIME_REQUEST',
  GET_ENVIRONMENT_PERFORMANCE_OPERATIONAL_TIME_FULFILLED = 'GET_ENVIRONMENT_PERFORMANCE_OPERATIONAL_TIME_FULFILLED',
  GET_ENVIRONMENT_PERFORMANCE_OPERATIONAL_TIME_REJECTED = 'GET_ENVIRONMENT_PERFORMANCE_OPERATIONAL_TIME_REJECTED',

  GET_ENVIRONMENT_MONITORING_REQUEST = 'GET_ENVIRONMENT_MONITORING_REQUEST',
  GET_ENVIRONMENT_MONITORING_FULFILLED = 'GET_ENVIRONMENT_MONITORING_FULFILLED',
  GET_ENVIRONMENT_MONITORING_REJECTED = 'GET_ENVIRONMENT_MONITORING_REJECTED',

  EDIT_ENVIRONMENT_MONITORING_REQUEST = 'EDIT_ENVIRONMENT_MONITORING_REQUEST',
  EDIT_ENVIRONMENT_MONITORING_FULFILLED = 'EDIT_ENVIRONMENT_MONITORING_FULFILLED',
  EDIT_ENVIRONMENT_MONITORING_REJECTED = 'EDIT_ENVIRONMENT_MONITORING_REJECTED',

  GET_MONITORING_HISTORY_REQUEST = 'GET_MONITORING_HISTORY_REQUEST',
  GET_MONITORING_HISTORY_FULFILLED = 'GET_MONITORING_HISTORY_FULFILLED',
  GET_MONITORING_HISTORY_REJECTED = 'GET_MONITORING_HISTORY_REJECTED',

  GET_PUBLICATION_SCHEDULE_REQUEST = 'GET_PUBLICATION_SCHEDULE_REQUEST',
  GET_PUBLICATION_SCHEDULE_FULFILLED = 'GET_PUBLICATION_SCHEDULE_FULFILLED',
  GET_PUBLICATION_SCHEDULE_REJECTED = 'GET_PUBLICATION_SCHEDULE_REJECTED',

  SET_PUBLICATION_SCHEDULE_REQUEST = 'SET_PUBLICATION_SCHEDULE_REQUEST',
  SET_PUBLICATION_SCHEDULE_FULFILLED = 'SET_PUBLICATION_SCHEDULE_FULFILLED',
  SET_PUBLICATION_SCHEDULE_REJECTED = 'SET_PUBLICATION_SCHEDULE_REJECTED',

  CANCEL_PUBLICATION_SCHEDULE_REQUEST = 'CANCEL_PUBLICATION_SCHEDULE_REQUEST',
  CANCEL_PUBLICATION_SCHEDULE_FULFILLED = 'CANCEL_PUBLICATION_SCHEDULE_FULFILLED',
  CANCEL_PUBLICATION_SCHEDULE_REJECTED = 'CANCEL_PUBLICATION_SCHEDULE_REJECTED',

  GET_BULK_CLIENTS_REQUEST = 'GET_BULK_CLIENTS_REQUEST',
  GET_BULK_CLIENTS_FULFILLED = 'GET_BULK_CLIENTS_FULFILLED',
  GET_BULK_CLIENTS_REJECTED = 'GET_BULK_CLIENTS_REJECTED',

  EDIT_BULK_CLIENTS_REQUEST = 'EDIT_BULK_CLIENTS_REQUEST',
  EDIT_BULK_CLIENTS_FULFILLED = 'EDIT_BULK_CLIENTS_FULFILLED',
  EDIT_BULK_CLIENTS_REJECTED = 'EDIT_BULK_CLIENTS_REJECTED',

  SET_SELECTED_ENVIRONMENT = 'SET_SELECTED_ENVIRONMENT',
  SET_PRODUCTION_ENVIRONMENT_REQUEST = 'SET_PRODUCTION_ENVIRONMENT_REQUEST',

  ACCEPT_STATUS_PENDING_REQUEST = 'ACCEPT_STATUS_PENDING_REQUEST',
  ACCEPT_STATUS_PENDING_FULFILLED = 'ACCEPT_STATUS_PENDING_FULFILLED',
  ACCEPT_STATUS_PENDING_REJECTED = 'ACCEPT_STATUS_PENDING_REJECTED',

  GET_BEHAVIOR_REPORT_FULFILLED = 'GET_BEHAVIOR_REPORT_FULFILLED',
  GET_BEHAVIOR_REPORT_REJECTED = 'GET_BEHAVIOR_REPORT_REJECTED',
  GET_BEHAVIOR_REPORT_REQUEST = 'GET_BEHAVIOR_REPORT_REQUEST',

  GET_DNS_REPORT_FULFILLED = 'GET_DNS_REPORT_FULFILLED',
  GET_DNS_REPORT_REJECTED = 'GET_DNS_REPORT_REJECTED',
  GET_DNS_REPORT_REQUEST = 'GET_DNS_REPORT_REQUEST',

  GET_MAINTENANCE_REPORT_FULFILLED = 'GET_MAINTENANCE_REPORT_FULFILLED',
  GET_MAINTENANCE_REPORT_REJECTED = 'GET_MAINTENANCE_REPORT_REJECTED',
  GET_MAINTENANCE_REPORT_REQUEST = 'GET_MAINTENANCE_REPORT_REQUEST',

  GET_PRODUCT_REPORT_FULFILLED = 'GET_PRODUCT_REPORT_FULFILLED',
  GET_PRODUCT_REPORT_REJECTED = 'GET_PRODUCT_REPORT_REJECTED',
  GET_PRODUCT_REPORT_REQUEST = 'GET_PRODUCT_REPORT_REQUEST',

  GET_PRODUCT_TYPE_REPORT_REQUEST = 'GET_PRODUCT_TYPE_REPORT_REQUEST',
  GET_PRODUCT_TYPE_REPORT_FULFILLED = 'GET_PRODUCT_TYPE_REPORT_FULFILLED',
  GET_PRODUCT_TYPE_REPORT_REJECTED = 'GET_PRODUCT_TYPE_REPORT_REJECTED',

  GET_PROVIDER_REPORT_FULFILLED = 'GET_PROVIDER_REPORT_FULFILLED',
  GET_PROVIDER_REPORT_REJECTED = 'GET_PROVIDER_REPORT_REJECTED',
  GET_PROVIDER_REPORT_REQUEST = 'GET_PROVIDER_REPORT_REQUEST',

  GET_REGION_REPORT_FULFILLED = 'GET_REGION_REPORT_FULFILLED',
  GET_REGION_REPORT_REJECTED = 'GET_REGION_REPORT_REJECTED',
  GET_REGION_REPORT_REQUEST = 'GET_REGION_REPORT_REQUEST',

  GET_STATUS_REPORT_FULFILLED = 'GET_STATUS_REPORT_FULFILLED',
  GET_STATUS_REPORT_REJECTED = 'GET_STATUS_REPORT_REJECTED',
  GET_STATUS_REPORT_REQUEST = 'GET_STATUS_REPORT_REQUEST',

  GET_VIRTUALIZER_REPORT_FULFILLED = 'GET_VIRTUALIZER_REPORT_FULFILLED',
  GET_VIRTUALIZER_REPORT_REJECTED = 'GET_VIRTUALIZER_REPORT_REJECTED',
  GET_VIRTUALIZER_REPORT_REQUEST = 'GET_VIRTUALIZER_REPORT_REQUEST',

  GET_ZERO_TRUST_REPORT_FULFILLED = 'GET_ZERO_TRUST_REPORT_FULFILLED',
  GET_ZERO_TRUST_REPORT_REJECTED = 'GET_ZERO_TRUST_REPORT_REJECTED',
  GET_ZERO_TRUST_REPORT_REQUEST = 'GET_ZERO_TRUST_REPORT_REQUEST',

  GET_TIMEZONES_REQUEST = 'GET_TIMEZONES_REQUEST',
  GET_TIMEZONES_FULFILLED = 'GET_TIMEZONES_FULFILLED',
  GET_TIMEZONES_REJECTED = 'GET_TIMEZONES_REJECTED',

  SET_SELECTED_TIMEZONE = 'SET_SELECTED_TIMEZONE',

  EXTEND_COMPLETION_DATE_REQUEST = 'EXTEND_COMPLETION_DATE_REQUEST',
  EXTEND_COMPLETION_DATE_FULFILLED = 'EXTEND_COMPLETION_DATE_FULFILLED',
  EXTEND_COMPLETION_DATE_REJECTED = 'EXTEND_COMPLETION_DATE_REJECTED',

  EXPORT_ENVIRONMENT_SUMMARY_REQUEST = 'EXPORT_ENVIRONMENT_SUMMARY_REQUEST',
  EXPORT_ENVIRONMENT_SUMMARY_FULFILLED = 'EXPORT_ENVIRONMENT_SUMMARY_FULFILLED',
  EXPORT_ENVIRONMENT_SUMMARY_REJECTED = 'EXPORT_ENVIRONMENT_SUMMARY_REJECTED',

  VALIDATE_ZERO_TRUST_REQUEST = 'VALIDATE_ZERO_TRUST_REQUEST',
  VALIDATE_ZERO_TRUST_FULFILLED = 'VALIDATE_ZERO_TRUST_FULFILLED',
  VALIDATE_ZERO_TRUST_REJECTED = 'VALIDATE_ZERO_TRUST_REJECTED',

  PUBLISH_IMAGE_REQUEST = 'PUBLISH_IMAGE_REQUEST',
  PUBLISH_IMAGE_FULFILLED = 'PUBLISH_IMAGE_FULFILLED',
  PUBLISH_IMAGE_REJECTED = 'PUBLISH_IMAGE_REJECTED',

  GET_PUBLISH_HISTORY_REQUEST = 'GET_PUBLISH_HISTORY_REQUEST',
  GET_PUBLISH_HISTORY_FULFILLED = 'GET_PUBLISH_HISTORY_FULFILLED',
  GET_PUBLISH_HISTORY_REJECTED = 'GET_PUBLISH_HISTORY_REJECTED',

  EXPORT_HISTORY_MONITORING_CSV_REQUEST = 'EXPORT_HISTORY_MONITORING_CSV_REQUEST',
  EXPORT_HISTORY_MONITORING_CSV_FULFILLED = 'EXPORT_HISTORY_MONITORING_CSV_FULFILLED',
  EXPORT_HISTORY_MONITORING_CSV_REJECTED = 'EXPORT_HISTORY_MONITORING_CSV_REJECTED',
  BLOCK_SERVER_ACTIONS_REQUEST = 'BLOCK_SERVER_ACTIONS_REQUEST',
  BLOCK_SERVER_ACTIONS_FULFILLED = 'BLOCK_SERVER_ACTIONS_FULFILLED',
  BLOCK_SERVER_ACTIONS_REJECTED = 'BLOCK_SERVER_ACTIONS_REJECTED',

  UNBLOCK_SERVER_ACTIONS_REQUEST = 'UNBLOCK_SERVER_ACTIONS_REQUEST',
  UNBLOCK_SERVER_ACTIONS_FULFILLED = 'UNBLOCK_SERVER_ACTIONS_FULFILLED',
  UNBLOCK_SERVER_ACTIONS_REJECTED = 'UNBLOCK_SERVER_ACTIONS_REJECTED',

  GET_ENVIRONMENT_SESSIONS_REQUEST = 'GET_ENVIRONMENT_SESSIONS_REQUEST',
  GET_ENVIRONMENT_SESSIONS_FULFILLED = 'GET_ENVIRONMENT_SESSIONS_FULFILLED',
  GET_ENVIRONMENT_SESSIONS_REJECTED = 'GET_ENVIRONMENT_SESSIONS_REJECTED',

  GET_LICENSE_GROUPS_REQUEST = 'GET_LICENSE_GROUPS_REQUEST',
  GET_LICENSE_GROUPS_FULFILLED = 'GET_LICENSE_GROUPS_FULFILLED',
  GET_LICENSE_GROUPS_REJECTED = 'GET_LICENSE_GROUPS_REJECTED',

  CREATE_LICENSE_GROUP_REQUEST = 'CREATE_LICENSE_GROUP_REQUEST',
  CREATE_LICENSE_GROUP_FULFILLED = 'CREATE_LICENSE_GROUP_FULFILLED',
  CREATE_LICENSE_GROUP_REJECTED = 'CREATE_LICENSE_GROUP_REJECTED',

  GET_LICENSE_GROUP_DETAILS_REQUEST = 'GET_LICENSE_GROUP_DETAILS_REQUEST',
  GET_LICENSE_GROUP_DETAILS_FULFILLED = 'GET_LICENSE_GROUP_DETAILS_FULFILLED',
  GET_LICENSE_GROUP_DETAILS_REJECTED = 'GET_LICENSE_GROUP_DETAILS_REJECTED',

  EDIT_LICENSE_GROUP_REQUEST = 'EDIT_LICENSE_GROUP_REQUEST',
  EDIT_LICENSE_GROUP_FULFILLED = 'EDIT_LICENSE_GROUP_FULFILLED',
  EDIT_LICENSE_GROUP_REJECTED = 'EDIT_LICENSE_GROUP_REJECTED',

  DELETE_LICENSE_GROUP_REQUEST = 'DELETE_LICENSE_GROUP_REQUEST',
  DELETE_LICENSE_GROUP_FULFILLED = 'DELETE_LICENSE_GROUP_FULFILLED',
  DELETE_LICENSE_GROUP_REJECTED = 'DELETE_LICENSE_GROUP_REJECTED',

  ADD_CLIENTS_TO_LICENSE_GROUP_REQUEST = 'ADD_CLIENTS_TO_LICENSE_GROUP_REQUEST',
  ADD_CLIENTS_TO_LICENSE_GROUP_FULFILLED = 'ADD_CLIENTS_TO_LICENSE_GROUP_FULFILLED',
  ADD_CLIENTS_TO_LICENSE_GROUP_REJECTED = 'ADD_CLIENTS_TO_LICENSE_GROUP_REJECTED',

  FULL_UPDATE_LICENSE_GROUP_CLIENTS_REQUEST = 'FULL_UPDATE_LICENSE_GROUP_CLIENTS_REQUEST',
  FULL_UPDATE_LICENSE_GROUP_CLIENTS_FULFILLED = 'FULL_UPDATE_LICENSE_GROUP_CLIENTS_FULFILLED',
  FULL_UPDATE_LICENSE_GROUP_CLIENTS_REJECTED = 'FULL_UPDATE_LICENSE_GROUP_CLIENTS_REJECTED',

  GET_CONNECTION_TYPE_ENVIRONMENT_REPORT_REQUEST = 'GET_CONNECTION_TYPE_ENVIRONMENT_REPORT_REQUEST',
  GET_CONNECTION_TYPE_ENVIRONMENT_REPORT_FULFILLED = 'GET_CONNECTION_TYPE_ENVIRONMENT_REPORT_FULFILLED',
  GET_CONNECTION_TYPE_ENVIRONMENT_REPORT_REJECTED = 'GET_CONNECTION_TYPE_ENVIRONMENT_REPORT_REJECTED',

  GET_ENVIRONMENT_ADVISORS_REQUEST = 'GET_ENVIRONMENT_ADVISORS_REQUEST',
  GET_ENVIRONMENT_ADVISORS_FULFILLED = 'GET_ENVIRONMENT_ADVISORS_FULFILLED',
  GET_ENVIRONMENT_ADVISORS_REJECTED = 'GET_ENVIRONMENT_ADVISORS_REJECTED',

  GET_ADMIN_PIN_REQUEST = 'GET_ADMIN_PIN_REQUEST',
  GET_ADMIN_PIN_FULFILLED = 'GET_ADMIN_PIN_FULFILLED',
  GET_ADMIN_PIN_REJECTED = 'GET_ADMIN_PIN_REJECTED',

  RESET_ADMIN_PIN_REQUEST = 'RESET_ADMIN_PIN_REQUEST',
  RESET_ADMIN_PIN_FULFILLED = 'RESET_ADMIN_PIN_FULFILLED',
  RESET_ADMIN_PIN_REJECTED = 'RESET_ADMIN_PIN_REJECTED',

  ENABLE_SERVER_MONITORING_MANAGEMENT_REQUEST = 'ENABLE_SERVER_MONITORING_MANAGEMENT_REQUEST',
  ENABLE_SERVER_MONITORING_MANAGEMENT_FULFILLED = 'ENABLE_SERVER_MONITORING_MANAGEMENT_FULFILLED',
  ENABLE_SERVER_MONITORING_MANAGEMENT_REJECTED = 'ENABLE_SERVER_MONITORING_MANAGEMENT_REJECTED',

  DISABLE_SERVER_MONITORING_MANAGEMENT_REQUEST = 'DISABLE_SERVER_MONITORING_MANAGEMENT_REQUEST',
  DISABLE_SERVER_MONITORING_MANAGEMENT_FULFILLED = 'DISABLE_SERVER_MONITORING_MANAGEMENT_FULFILLED',
  DISABLE_SERVER_MONITORING_MANAGEMENT_REJECTED = 'DISABLE_SERVER_MONITORING_MANAGEMENT_REJECTED',

  GET_ALL_SERVERS_MONITORING_STATUS_REQUEST = 'GET_ALL_SERVERS_MONITORING_STATUS_REQUEST',

  GET_SERVER_MONITORING_STATUS_REQUEST = 'GET_SERVER_MONITORING_STATUS_REQUEST',
  GET_SERVER_MONITORING_STATUS_FULFILLED = 'GET_SERVER_MONITORING_STATUS_FULFILLED',
  GET_SERVER_MONITORING_STATUS_REJECTED = 'GET_SERVER_MONITORING_STATUS_REJECTED',
}

export default Types;
